import { createGraphQLFetchStrategy } from "./graphql.js";
const FRAGMENT_ARTICLE_BASIC = `
  fragment ArticleBasicFields on articles_today_Entry {
    id
    title
    url
  }
`;
const FRAGMENT_ARTICLE_DATES = `
  fragment ArticleDateFields on articles_today_Entry {
    date: postDate
    dateFormatted: postDate @formatDateTime(format: "M d, Y")
  }
`;
const FRAGMENT_ARTICLE_CONTENT = `
  fragment ArticleContentFields on articles_today_Entry {
    summary: genericText
    image: articlesHeroImage {
      url
      ... on hero_Asset {
        id
        altText: genericText
      }
    }
  }
`;
const FRAGMENT_ARTICLE_CATEGORIES = `
  fragment ArticleCategoryFields on articles_today_Entry {
    categories: categoryTodaySectionMultiple {
      title
      url
    }
  }
`;
const ARTICLES_QUERY = `
  query getArticles($related: [QueryArgument], $relatedToAll: [QueryArgument], $limit: Int, $offset: Int, $not: [QueryArgument]) {
    entryCount(section: "articles", relatedTo: $related, relatedToAll: $relatedToAll)
    entries(
      section: "articles",
      relatedTo: $related,
      relatedToAll: $relatedToAll,
      limit: $limit,
      offset: $offset,
      id: $not
    ) {
      ... on articles_today_Entry {
        ...ArticleBasicFields
        ...ArticleDateFields
        ...ArticleContentFields
        ...ArticleCategoryFields
      }
    }
  }
  ${FRAGMENT_ARTICLE_BASIC}
  ${FRAGMENT_ARTICLE_DATES}
  ${FRAGMENT_ARTICLE_CONTENT}
  ${FRAGMENT_ARTICLE_CATEGORIES}
`;
const newsFetchStrategy = createGraphQLFetchStrategy({
  endpoint: "https://today.umd.edu/graphql",
  queries: {
    entries: ARTICLES_QUERY
  },
  transformResponse: (data) => {
    if (!data || !data.data || !data.data.entries) {
      return null;
    }
    return data.data.entries || null;
  },
  transformCount: (data) => {
    if (!data || !data.data) {
      return 0;
    }
    return data.data.entryCount || 0;
  },
  composeVariables: (baseVariables) => {
    const { categories, isUnion, entriesToRemove, ...rest } = baseVariables;
    const variables = { ...rest };
    if (!isUnion && categories) {
      variables.relatedToAll = categories;
    }
    if (isUnion && categories) {
      variables.related = categories;
    }
    if (entriesToRemove) {
      variables.not = ["not", ...entriesToRemove];
    }
    return variables;
  }
});
export {
  ARTICLES_QUERY,
  newsFetchStrategy
};
//# sourceMappingURL=news.js.map
